// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page":"page_Q9Aju first_!block last_hidden"};